module.exports = __webpack_public_path__ + "img/nuvemshop.e72387ec.png";